<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Сэлбэг нэмэх</h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <label>Нэр</label>
                      <input v-model.trim="lesson.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Нэр">
                    </div>
                    <div class="form-group">
                      <label>Тайлбар мэдээлэл</label>
                      <textarea v-model.trim="lesson.description" type="text" class="form-control" id="exampleInputPassword" placeholder="Дэлгэрэнгүй" rows="10"/>
                    </div>
                    <div class="form-group">
                      <label>Үнэ</label>
                      <input v-model.number="lesson.price" type="number" class="form-control"  placeholder="Үнэ">
                    </div>
                    <div class="form-group">
                      <label>Үлдэгдэл</label>
                      <input v-model.number="lesson.quantity" type="number" class="form-control"  placeholder="Үлдэгдэл">
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Дэлгүүр:</label>
                        <select class="form-control" >
                          <option >{{storeId}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Ангилал:</label>
                          <select class="form-control" v-model="school" @change="schoolChanged">
                            <option v-for="(school, index) in schools" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.data().name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="school!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Төрөл:</label>
                          <select class="form-control" v-model="department" >
                            <option v-for="(dep, index) in school.departments" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.data().name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="department!=null">
                      <label for="exampleFormControlSelect1">Дэд төрөл:</label>
                      <select class="form-control" v-model="program" >
                        <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{index+1}}.  {{pro.data().name}}</option>
                      </select>
                    </div>

                    <hr/>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Үйлдвэрлэгч:</label>
                          <select class="form-control" v-model="cartype" @change="carmark=null; caryear=null; carmodel=null">
                            <option v-for="(cartype, index) in cartypes" v-bind:key="cartype.id" v-bind:value="cartype">{{index+1}}.  {{cartype.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="cartype!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Марк:</label>
                          <select class="form-control" v-model="carmark"  @change="caryear=null; carmodel=null" >
                            <option v-for="(dep, index) in cartype.marks" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="carmark!=null">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Он:</label>
                          <select class="form-control" v-model="caryear"  @change="carmodel=null">
                            <option v-for="(cartype, index) in carmark.years" v-bind:key="cartype.id" v-bind:value="cartype">{{index+1}}.  {{cartype.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="caryear!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Модел:</label>
                          <select class="form-control" v-model="carmodel" >
                            <option v-for="(dep, index) in caryear.models" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
       
  
                    <hr/>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>
                  
                 
                
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
    name: "LessonAdd",
    data() {
        return {
            lesson: {
                name: '',
                engName:'',
                description: '',
                results:[],
                semester:null, 
                quantity:null,
                price:null,
                types:[]
               
            },
            performingRequest:false,
            result:'',
            schools:[],
            school:null,
            department:null,
            program:null,
            semesters:[],
            semester:null,
            lessonTypes:[
              "Ерөнхий эрдэм",
              "Мэргэжлийн",
              "Мэргэжлийн суурь",
              "Сонгох",
              "Магистр",
              "Доктор"
            ],
            cartypes:[],
            cartype:null,
            carmark:null,
            caryear:null,
            carmodel:null
 
        };
    },
    methods: {
        save() {
         
            this.performingRequest = true
            if(this.lesson!=null && this.lesson.name!=''){
              this.lesson.name=this.capitalizeFirstLetter(this.lesson.name);
                this.lesson.userId=this.$store.getters.currentUser.uid;
                this.lesson.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
                if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null)
                  this.lesson.teacher=this.$store.getters.userProfile.customer;
                this.lesson.createdAt=new Date();
                this.lesson.code=new Date().getTime();

                this.lesson.category=null;
                if(this.school!=null){
                  this.lesson.category=this.school.ref;
                  this.school.ref.update({
                    'numberOfSelbeg': fb.firestore.FieldValue.increment(1)
                  });
                }
                this.lesson.type=null
                if(this.department!=null){
                  this.lesson.type=this.department.ref
                  this.department.ref.update({
                    'numberOfSelbeg': fb.firestore.FieldValue.increment(1)
                  })
                }
                this.lesson.subtype=null;
                if(this.program!=null){
                  this.lesson.subtype=this.program.ref
                  this.program.ref.update({
                    'numberOfSelbeg': fb.firestore.FieldValue.increment(1)
                  })
                }

                this.lesson.cartype=null;
                if(this.cartype!=null){
                  this.lesson.cartype=this.cartype.ref;
                  this.cartype.ref.update({
                    'numberOfSelbeg': fb.firestore.FieldValue.increment(1)
                  });
                }

                this.lesson.carmark=null
                if(this.carmark!=null){
                  this.lesson.carmark=this.carmark.ref;
                  this.carmark.ref.update({
                    'numberOfSelbeg': fb.firestore.FieldValue.increment(1)
                  })
                }
                this.lesson.caryear=null;
                if(this.caryear!=null){
                  this.lesson.caryear=this.caryear.ref
                  this.caryear.ref.update({
                    'numberOfSelbeg': fb.firestore.FieldValue.increment(1)
                  })
                }
                this.lesson.carmodel=null;
                if(this.carmodel!=null){
                  this.lesson.carmodel=this.carmodel.ref
                  this.carmodel.ref.update({
                    'numberOfSelbeg': fb.firestore.FieldValue.increment(1)
                  })
                }

                if(this.storeId!=null && this.storeId!='' && this.storeId!='new'){
                  this.lesson.store=fb.db.collection("stores").doc(this.storeId);
                  fb.db.collection("stores").doc(this.storeId).collection("selbeg").doc().set(this.lesson);
                  fb.db.collection("stores").doc(this.storeId).update({'numberOfSelbeg':fb.firestore.FieldValue.increment(1)});
                }

          
                this.$router.back();
            }
            else{
              alert("Та хичээлийнхээ нэр болон улирал оруулна уу");
            }
        },
        setLesson(){
          this.lesson={
                name: '',
                description: '',
                included:[],
                lectureCode:'',
                profession:"",
                requirements:[],
                results:[],
                whatlearned:[],
                skills:[],
                handlaga:[],
                semester:null,
                quantity:null,
                price:null,
                types:[]

            }
        },
        addIncluded(){
          if(this.included!=null && this.included!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.included.push(this.included)
            this.included=''
          }
        },
        addRequirement(){
          if(this.requirement!=null && this.requirement!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.requirements.push(this.requirement)
            this.requirement=''
          }
        },
        addResult(){
          if(this.result!=null && this.result!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.results.push(this.result)
            this.result=''
          }
        },
        addLearned(){
          if(this.whatlearned!=null && this.whatlearned!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.whatlearned.push(this.whatlearned)
            this.whatlearned=''
          }
        },
        addSkill(){
          if(this.skill!=null && this.skill!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.skills.push(this.skill)
            this.skill=''
          }
        },
        addHandlaga(){
          if(this.handlagaText!=null && this.handlagaText!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.handlaga.push(this.handlagaText)
            this.handlagaText=''
          }
        },
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },
        
        _getSchools(){
          fb.db.collection("selbegtypes").orderBy("createdAt")
          .get()
          .then(querySnapshot=> {
              querySnapshot.forEach(schoolData=> {
                
                this._getDepartments(schoolData.id, schoolData);
                this.schools.push(schoolData);

              });
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });

        },
        _getDepartments(schoolId, schoolData){
          schoolData.ref.collection("children").orderBy("createdAt")
          .get()
          .then(querySnapshot=> {
              let deps=[]
              querySnapshot.forEach(depdata=> {
                this._getPros(depdata)
                deps.push(depdata);


              });
              schoolData.departments=deps;

          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getPros(depdata){
          depdata.ref.collection("children").orderBy("createdAt")
          .get()
          .then(querySnapshot=> {
            let pros=[]
              querySnapshot.forEach(prodata=> {
                pros.push(prodata);
              });
              depdata.programs=pros;

              
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        schoolChanged(){
          this.department=null
          this.program=null
        },
        addType(type){
          if(this.lesson.types==null || this.lesson.types==undefined)
            this.lesson.types=[];
          if(!this.lesson.types.includes(type))
            this.lesson.types.push(type);
          else
            this.lesson.types.splice(this.lesson.types.indexOf(type), 1); 
        },
        capitalizeFirstLetter(str){
          return  str.charAt(0).toUpperCase() + str.slice(1);
        },

        async getCategories(){
          var cartypes=await fb.db.collection("cartypes").get();
          if(!cartypes.empty){
            for(const cc of cartypes.docs){
              let c=cc.data();
              c.id=cc.id;
              c.marks=[];
              c.ref=cc.ref;
              this.getMarks(c, cc.ref);
              this.cartypes.push(c);
            }
          }
        },
        async getMarks(obj, ref){
          var cartypes=await ref.collection("marks").get();
          if(!cartypes.empty){
            for(const cc of cartypes.docs){
              let c=cc.data();
              c.id=cc.id;
              c.years=[];
              c.ref=cc.ref;
              this.getYears(c, cc.ref);
              obj.marks.push(c);
            }
          }
        },
        async getYears(obj, ref){
          var cartypes=await ref.collection("years").get();
          if(!cartypes.empty){
            for(const cc of cartypes.docs){
              let c=cc.data();
              c.id=cc.id;
              c.models=[];
              c.ref=cc.ref;
              this.getModels(c, cc.ref);
              obj.years.push(c);
            }
          }
        },
        async getModels(obj, ref){
          var cartypes=await ref.collection("models").get();
          if(!cartypes.empty){
            for(const cc of cartypes.docs){
              let c=cc.data();
              c.id=cc.id;
              c.ref=cc.ref;
              obj.models.push(c);
            }
          }
        },


    }, 
   
    created() {
        var _this=this;
        if(this.storeId!=null && this.storeId!=''){
          this._getSchools();
          this.getCategories();
        }
            
    },
    props: {
      storeId: { 
        required: true,
      }
    }
  
};
</script>

